import { render, staticRenderFns } from "./ChatTab.vue?vue&type=template&id=a207cada&scoped=true"
import script from "./ChatTab.vue?vue&type=script&lang=js"
export * from "./ChatTab.vue?vue&type=script&lang=js"
import style0 from "./ChatTab.vue?vue&type=style&index=0&id=a207cada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a207cada",
  null
  
)

export default component.exports